import React from "react";
import "./footer.css";
import {
  AiFillLinkedin,
  AiOutlineInstagram,
  AiOutlineTwitter,
  AiOutlineYoutube,
} from "react-icons/ai";

function Footer() {
  const year = new Date().getFullYear();

  const socialLinks = [
    {
      href: "https://www.linkedin.com/in/sebassotelo/",
      label: "LinkedIn",
      icon: AiFillLinkedin,
    },
    {
      href: "https://www.youtube.com/@SebassDev",
      label: "YouTube",
      icon: AiOutlineYoutube,
    },
    {
      href: "https://www.instagram.com/_sebasdev/",
      label: "Instagram",
      icon: AiOutlineInstagram,
    },
    {
      href: "https://twitter.com/_sebassotelo",
      label: "Twitter",
      icon: AiOutlineTwitter,
    },
  ];

  return (
    <footer className="footer">
      <div className="footer__glow footer__glow--one" />
      <div className="footer__glow footer__glow--two" />

      <div className="footer__shell">
        <div className="footer__content">
          <div className="footer__text">
            <p className="footer__name">
              Desarrollado por <strong>Sebas Sotelo</strong>
            </p>
            <p className="footer__role">Full Stack Software Developer & AI Engineer</p>
          </div>

          <div className="footer__socials">
            {socialLinks.map(({ href, label, icon: Icon }) => (
              <a
                key={label}
                href={href}
                target="_blank"
                rel="noreferrer"
                aria-label={label}
                className="footer__social"
              >
                <Icon />
              </a>
            ))}
          </div>
        </div>

        <div className="footer__bottom">
          <p>{year}</p>
          <p>Portfolio personal y profesional</p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
